// extracted by mini-css-extract-plugin
export var chevronIcon = "_cn-2";
export var teamName = "_cn-1";
export var teamSwitcherButton = "_cn-0";